<template>
  <section>
    <b-modal width="680px" :active.sync="isRootEditModalActive" :on-cancel="closeRootEditModal">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <div class="card-header-title edit-title-wrapper">
            <span class="edit-title">サイトマップURL編集</span>
          </div>
        </header>
        <div class="card-content disp-scroll" style="border-radius: 5px;">
          <span class="edit-title">サイトマップURL一覧</span>
          <b-tabs class="tab-form" type="is-boxed;">
            <b-tab-item label="作成済サイトマップ">
              <div class="tab-item">
                <table style="width: 100%;">
                  <tr style="border-bottom: solid 2px #ccc; background: white;">
                    <th class="cell-class" style="padding: 5px;">サイトマップ名</th>
                    <th class="cell-class" style="padding: 5px;">削除</th>
                  </tr>
                  <tr style="border-bottom: solid thin #ccc; background: white;" v-if="getSitemapRootList <= 0">
                    <td colspan="4">表示できるサイトマップがありませんでした。</td>
                  </tr>
                  <tr v-for="(sitemap, idx) in sitemapRootList" :key="idx" style="border-bottom: solid thin #ccc; background: white;" v-else>
                    <td class="cell-class" style="height: 50px; width: calc(100% - 100px); padding: 5px; display: flex; align-items: center;">{{sitemap.root_url}}</td>
                    <td class="cell-class" style="height: 50px; padding: 5px;">
                      <button @click="deleteSitemapRootConfirm(sitemap)" class="button is-danger" :disabled="sitemapRootList.length <= 1"><span class="mdi mdi-delete"></span></button>
                    </td>
                  </tr>
                </table>
              </div>
            </b-tab-item>
            <b-tab-item label="作成待機中サイトマップ">
              <div class="tab-item">
                <table style="width: 100%;">
                  <tr style="border-bottom: solid 2px #ccc; background: white;" class="flex">
                    <th class="cell-class" style="width: 45% ;">URL</th>
                    <th class="cell-class" style="width: 20% ;">状態</th>
                    <th class="cell-class" style="width: 20% ;">作成日</th>
                    <th class="cell-class" style="width: 15% ;">削除</th>
                  </tr>          
                  <tr style="border-bottom: solid thin #ccc; background: white;" v-if="getSitemapWaitList <= 0">
                    <td colspan="4">表示できる待機中サイトマップがありませんでした。</td>
                  </tr>
                  <tr v-for="(sitemapWait, wIdx) in sitemapWaitList" :key="wIdx" style="border-bottom: solid thin #ccc; background: white;" class="flex" v-else>                  
                    <td class="cell-class" style="height: 50px; width: 30% ; padding: 5px; align-items: center;">{{sitemapWait.url}}</td>
                    <td class="cell-class" style="vertical-align: middle; width: 30%">{{sitemapWait.status}}</td>        
                    <td class="cell-class" style="vertical-align: middle; width: 40%">{{getMoment(sitemapWait.created_at)}}</td>                     
                    <td class="cell-class" style="padding: 5px;">
                      <button @click="deleteSitemapWaitConfirm(sitemapWait)" class="button is-danger" :disabled="sitemapWait.status !== '待機中'"><span class="mdi mdi-delete"></span></button>
                    </td>
                  </tr>
                </table>
              </div>
            </b-tab-item>
          </b-tabs>
        </div>
        <hr>
        <b-field>
          <div class="split-box-form">
            <div class="split-box-left">
              <p>新規追加</p>
            </div>
            <div class="split-box-right">
              <input class="input is-small" placeholder="作成するサイトマップのURLを入力" v-model="createSitemapUrl"/>
              <button class="button is-primary is-small" @click="registSitemapWait(createSitemapUrl)" :disabled="!createSitemapUrl">新しく追加</button>
            </div>
          </div>
        </b-field>
      </div>
    </b-modal>
  </section>
</template>

<script>
import moment           from 'moment'

// 外部関数
export default {
  name: 'ModalSitemapRootEdit',
  componentName: 'ModalSitemapRootEdit',
  computed: {
    getSitemapRootList () {
      if(this.sitemapRootList) {
        return this.sitemapRootList
      } else {
        return []
      }
    },
    getSitemapWaitList () {
      if (this.sitemapWaitList) {
        return this.sitemapWaitList
      } else {
        return []
      }

    }
  },
  data () {
    return {
      /** モーダルダイアログ開閉フラグ */
      isRootEditModalActive: this.isSitemapRootEditModalOpen,
      /** 新規作成サイトマップルートURL */
      createSitemapUrl     : ''
    }
  },
  props: {
    /** モーダルダイアログ開閉フラグ */
    isSitemapRootEditModalOpen: {
      type    : Boolean,
      default : false,
      required: true
    },
    /** 待機中サイトマップルートリスト */
    sitemapWaitList: {
      required: true
    },
    /** サイトマップルートリスト */
    sitemapRootList: {
      required: true
    }
  },
  watch: {
    /** モーダルダイアログ開閉フラグ */
    isSitemapRootEditModalOpen () {
      this.isRootEditModalActive = this.isSitemapRootEditModalOpen
    }
  },
  methods: {
    /** 日付表示形式 */
    getMoment (date) {
      // 時間表示指定
      return moment(date).format('YYYY-MM-DD')
    },
    /** 新規サイトマップルート登録 */
    registSitemapWait (createSitemapUrl) {
      this.$emit('registSitemapWait', createSitemapUrl)
      this.createSitemapUrl = ''
    },
    /** サイトマップルート削除確認ダイアログ表示 */
    deleteSitemapRootConfirm (sitemap) {
      this.$emit('deleteSitemapRootConfirm', sitemap)
    },
    /** 待機中サイトマップルート削除確認ダイアログ表示 */
    deleteSitemapWaitConfirm (sitemapWait) {
      this.$emit('deleteSitemapWaitConfirm', sitemapWait)
    },
    /** サイトマップルート編集ダイアログクローズ */
    closeRootEditModal () {
      this.$emit('closeRootEditModal')
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-title-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  border-bottom: solid thin #ccc;
}
.edit-title {
  font-size: 22px;
  font-weight: 700;
}
.tab-form {
  width:100%;
  height: 400px;
  padding: 8px;
}
.tab-item {
  width: 100%;
  height: calc(100% - 50px);
  padding:12px;
  //overflow-y: scroll !important;
}
.cell-class {
  padding: 0.5em !important;
}
.split-box-form {
  width: 100%;
  display: flex;
  padding-bottom: 24px;
}
.split-box-left {
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.split-box-right {
  width: 80%;
  font-size: 13px;
  padding-right: 48px;
  justify-content: flex-start;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/users/sitemap/ModalSitemapRootEdit.vue